import React, { useState, useEffect } from "react";
import axios from "../../../api/axios";
import ComplaintsTable from "./components/ComplaintsTablePolice";

const ComplaintsPage = () => {
  const [data, setData] = useState([]);
  // NEW: police status filter
  const [policeStatusFilter, setPoliceStatusFilter] = useState("Pending"); // default: show pending for police

  const fetchComplaints = async () => {
    const token = "Bearer " + localStorage.getItem("token")?.replace(/"/g, "");
    try {
      const response = await axios.get("/api/complaints/all-complaints", {
        headers: { Authorization: token, "Content-Type": "application/json" },
        params: {
          adminStatus: "Approved",                              // always approved by admin
          policeStatus: policeStatusFilter || undefined,        // filterable
        },
      });
      setData(response.data);
    } catch (err) {
      console.error("Failed to fetch complaints:", err);
    }
  };

  useEffect(() => {
    fetchComplaints();
    // re-fetch whenever police filter changes
  }, [policeStatusFilter]);

  return (
    <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
      {/* Police status filter buttons */}
      <div className="mb-4 flex flex-wrap gap-2">
        <button
          onClick={() => setPoliceStatusFilter("")} // All police statuses
          className={`rounded px-3 py-2 ${policeStatusFilter === "" ? "bg-brand-700 text-white" : "bg-gray-200"}`}
        >
          Të gjitha
        </button>
        <button
          onClick={() => setPoliceStatusFilter("Pending")}
          className={`rounded px-3 py-2 ${policeStatusFilter === "Pending" ? "bg-brand-700 text-white" : "bg-gray-200"}`}
        >
          Në pritje
        </button>
        <button
          onClick={() => setPoliceStatusFilter("Approved")}
          className={`rounded px-3 py-2 ${policeStatusFilter === "Approved" ? "bg-brand-700 text-white" : "bg-gray-200"}`}
        >
          Aprovuar
        </button>
        <button
          onClick={() => setPoliceStatusFilter("Refused")}
          className={`rounded px-3 py-2 ${policeStatusFilter === "Refused" ? "bg-brand-700 text-white" : "bg-gray-200"}`}
        >
          Refuzuar
        </button>
      </div>

      <ComplaintsTable tableData={data} />
    </div>
  );
};

export default ComplaintsPage;
